import React from "react";
import { Navigate } from "react-router-dom";

export default function ReviewedPage() {
    return <Navigate to="/admin/courses" replace />;
}
